<template>
    <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-6 col-md-12 mb-25 wow move-up">
            <div class="ht-service-box--three">
                <div class="service-box-wrap">
                    <div class="image__media">
                        <img :src="item.icon" class="img-fluid" alt="Icon">
                    </div>
                    <div class="content">
                        <h5 class="heading font-weight--light">{{ item.heading }}</h5>
                        <div class="service_text">{{ item.text }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PaymentFeature',
        data (){
            return {
                items: [
                    {
                        icon: require('@/assets/static-img/icons/advantage-01.png'),
                         heading:'Messaging Apps Order Form', 
                        text:'Create order form for WhatsApp, Telegram or WeChat and choose products to sell. Customised forms for respective messaging apps will be created and just share links with your potential buyers!'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-02.png'), 
                        heading:'Quick and Simple Setup', 
                        text:'No technical knowledge or coding required. Easily setup your social commerce store in just a few minutes!'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-03.png'), 
                        heading:'Mobile Commerce Ready', 
                        text:'Lightweight mobile friendly design for everyone to enjoy great user experience when purchasing from your online store. You can also manage your store anytime, anywhere with any device!'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-04.png'), 
                        heading:'Multiple Payment Options', 
                        text:'Set up payment gateway in a minute and offer your customers with various payment methods including credit cards and bank transfer.'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-05.png'), 
                        heading:'Auto-generated Air Waybill', 
                        text:'No more handwritten consignment note. Air waybill is automatically filled with shipping information. Just print it out!'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-06.png'), 
                        heading:'Complete Management Systems', 
                        text:'Track and manage your orders, customers and inventory with ease. Follow up unpaid orders with customers. Fulfil paid orders with integrated and automated shipping solutions.'
                    },
                    {
                        icon: require('@/assets/static-img/icons/advantage-07.png'), 
                        heading:'Analytics and Reporting', 
                        text:'Gain insights by monitoring real time data related to customers behaviour, your products, sales and team members performance to support your business growth.'
                    },
                ]
            }
        }
    }
</script>
